import React from "react";
import {cn} from "../../lib/Utils";

interface SimpleLinkProps {
    name: string;
    href: string;
    openInNewTab?: boolean;
    classNames?: string;
}

export const SimpleLink = ({name, href, openInNewTab = false, classNames}: SimpleLinkProps) => {
    return (
        <a
            href={href}
            className={cn("block text-sm text-surface-800 hover:text-brand-600 focus-ring", classNames)}
            {...(openInNewTab ? {target: "_blank", rel: "noopener noreferrer"} : {})}
        >
            {name}
        </a>
    );
};













